module.exports = __webpack_public_path__ + "img/rose.a1550b40.svg";